const projectData = {
  project: [
    {
      name: "GoGoBangla",
      url: "gogobangla",
      website: "https://gogobangla.com",
      featuredImage: "gogobangla.webp",
      desc: "GoGoBangla provides a complete delivery solution for e-commerce and F-commerce merchants in Bangladesh.",
      category: "E-Commerce Logistics & Delivery Platform",
      role: "Software Engineer",
      technologies: ["JavaScript", "React.js", "Node.js", "REST API", "HTML5/CSS3"],
      features: [
        "End-to-end parcel delivery management and merchant portal",
        "Automated shipping cost calculation and area coverage index",
        "Real-time parcel status tracking and order status updates"
      ],
      gallery: [
        "gogobangla-1.webp",
        "gogobangla-2.webp",
        "gogobangla-3.webp",
        "gogobangla-4.webp",
        "gogobangla-5.webp",
        "gogobangla-6.webp",
        "gogobangla-7.webp",
        "gogobangla-8.webp",
        "gogobangla-9.webp"
      ],
      footer: "End of GoGoBangla website gallery."
    },
    {
      name: "Chalao",
      url: "chalao",
      website: "",
      featuredImage: "chalao.webp",
      desc: "Chalao is the orders delivery mobile application for Chaldal and GoGoBangla logistics operations.",
      category: "Mobile Application & Logistics",
      role: "Mobile Application Engineer",
      technologies: ["React Native", "JavaScript", "Mobile App Development", "REST API"],
      features: [
        "Real-time order dispatch and assignment for delivery agents",
        "Delivery route optimization and instant status updates",
        "Proof of delivery recording and parcel tracking"
      ],
      gallery: [
        "chalao-1.webp",
        "chalao-2.webp",
        "chalao-3.webp"
      ],
      footer: "End of Chalao mobile app gallery."
    },
    {
      name: "Kotha",
      url: "kotha",
      website: "https://kotha.app",
      featuredImage: "kotha.webp",
      desc: "Kotha is a Bangladeshi social media, messaging, and lifestyle mobile and web application.",
      category: "Social Media & Lifestyle Platform",
      role: "Software Engineer",
      technologies: ["HTML5", "CSS3", "JavaScript"],
      features: [
        "Social feeds, posts, multimedia sharing, and interactive content",
        "Direct messaging and real-time community chat features",
        "Localized digital services, content discovery, and lifestyle mini-apps"
      ],
      gallery: [
        "kotha-1.webp",
        "kotha-2.webp",
        "kotha-3.webp",
        "kotha-4.webp",
        "kotha-5.webp",
        "kotha-6.webp"
      ],
      footer: "End of Kotha gallery."
    },
    {
      name: "Tradelert",
      url: "tradelert",
      website: "http://www.tradelert.com/",
      featuredImage: "tradelert.webp",
      desc: "Tradelert is a modern trading alert platform designed for stock, cryptocurrency, and ETF price movements.",
      category: "Financial Technology & Trading Alerts",
      role: "Software Engineer",
      technologies: ["JavaScript", "React.js", "Python", "REST API", "Financial Data Systems"],
      features: [
        "Real-time market price monitoring and automated alert triggers",
        "Stock, crypto, and ETF volatility and threshold notifications",
        "Customizable alert rules and financial data visualizer"
      ],
      gallery: [
        "tradelert-1.webp",
        "tradelert-2.webp",
        "tradelert-3.webp",
        "tradelert-4.webp",
        "tradelert-5.webp",
        "tradelert-6.webp",
        "tradelert-7.webp",
        "tradelert-8.webp",
        "tradelert-9.webp"
      ],
      footer: "End of Tradelert gallery."
    },
    {
      name: "JiggleMed",
      url: "jigglemed",
      website: "http://jigglemed.com",
      featuredImage: "jigglemed.webp",
      desc: "JiggleMed connects medical professionals with a searchable database of FDA-approved endovascular devices and specs.",
      category: "Healthcare & Medical Device Platform",
      role: "Software Engineer",
      technologies: ["HTML5", "CSS3", "JavaScript"],
      features: [
        "Searchable reference database for FDA-approved medical devices",
        "Technical specifications and clinical usage documentation",
        "Interactive platform for the global endovascular medical community"
      ],
      gallery: [
        "jigglemed-1.webp",
        "jigglemed-2.webp",
        "jigglemed-3.webp"
      ],
      footer: "End of JiggleMed gallery."
    },
    {
      name: "Good Guy Vapes Rewards",
      url: "goodguyvapes",
      website: "http://goodguyvapes.shoppio.co",
      featuredImage: "goodguyvapes.jpg",
      desc: "Good Guy Vapes Rewards is a customer loyalty platform enabling customers to earn and redeem points for rewards.",
      category: "E-Commerce & Loyalty Rewards",
      role: "Web Application Developer",
      technologies: ["JavaScript", "React.js", "REST API", "HTML5/CSS3"],
      features: [
        "Customer loyalty points balance and transaction history",
        "Rewards redemption catalog and store promotions integration",
        "User membership management and tier progression"
      ],
      gallery: [
        "goodguyvapes-1.jpg",
        "goodguyvapes-2.jpg",
        "goodguyvapes-3.jpg",
        "goodguyvapes-4.jpg",
        "goodguyvapes-5.jpg",
        "goodguyvapes-6.jpg",
        "goodguyvapes-7.jpg",
        "goodguyvapes-8.jpg",
        "goodguyvapes-9.jpg",
        "goodguyvapes-10.jpg"
      ],
      footer: "End of Good Guy Vapes Rewards gallery."
    },
    {
      name: "Celerity Agency",
      url: "celerity-agency",
      website: "http://www.celerity-agency.com/",
      featuredImage: "celerity-agency.webp",
      desc: "Mobile application development agency based in Paris, France, building digital solutions for global clients.",
      category: "Mobile Application Agency",
      role: "Mobile & Web Software Engineer",
      technologies: ["React.js", "JavaScript", "Mobile App Development", "UI/UX Engineering"],
      features: [
        "Agency portfolio showcase highlighting international client projects",
        "Mobile application engineering and cross-platform design showcase",
        "Service capabilities and client case studies presentation"
      ],
      gallery: [
        "celerity-agency-1.webp",
        "celerity-agency-2.webp",
        "celerity-agency-3.webp",
        "celerity-agency-4.webp",
        "celerity-agency-5.webp",
        "celerity-agency-6.webp",
        "celerity-agency-7.webp",
        "celerity-agency-8.webp",
        "celerity-agency-9.webp"
      ],
      footer: "End of Celerity Agency gallery."
    }
  ]
};

export default projectData;
